import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const ThankYou = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Set a timer to redirect back to the form after 3 seconds
        const timer = setTimeout(() => {
            navigate('/');
        }, 3000);

        // Cleanup the timer if the component unmounts
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="visitor-container thank-you-container">
            <div className="video-overlay"></div>
            <video className="background-video" autoPlay loop muted>
                <source src="https://redrocket.energy/wp-content/uploads/2024/05/RedRocketAnimation1200p_Loop.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className="form-wrapper thank-you-wrapper">
                <div className="logo-section">
                    <img
                        src="https://images7.bamboohr.com/601218/logos/cropped.jpg?v=28"
                        alt="Red Rocket Logo"
                        className="logo"
                    />
                    <h1 className="form-title">Thank You!</h1>
                </div>

                <div className="thank-you-message">
                    <p>Your information has been submitted successfully.</p>
                    <h4>DO NOT FORGET TO COLLECT YOUR PARKING TICKET</h4>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;